import RegisterCompany from "app/pages/company/RegisterCompany1";
import RegisterCleaner from "app/pages/cleaner/RegisterCleaner";
import { RegisterAsIndividual } from "app/pages/individual/account/RegisterAsIndividual";

type TargetType = "company" | "cleaner" | "individual";


export const TargetProfileOnboarding = ({
  targetType,
}: {
  targetType: TargetType;
}) => {
  if (targetType === "company") return <RegisterCompany targetProfile />;
  if (targetType === "cleaner") return <RegisterCleaner targetProfile />;
  return <RegisterAsIndividual targetProfile />;
};
